import './components/ga-events';            //should be on top of each page's JS file
import './components/swipe-for-more';       // should be as soon as possible
import './parts/navigation';
import './parts/keyboard-navigation';
import './parts/accept-cookies';
import './parts/ftc-disclosure';
import './components/accessibility-widget';
import './components/js-links';
import './components/svg';
import './parts/testing-methodology-cards';
import $ from 'cash-dom';
import Tooltips from './components/tooltips';
import CustomSelect from './components/custom-select';

$(function () {
  Tooltips.getInstance().initOnce();
  CustomSelect.init();
});
